<template>
	<div class="header-container width-100 display-flex flex-justify-space-between flex-align-center px-6">
		<div class="input-container display-flex flex-row flex-centerize">
			<ModuleTypeIcon serviceSlug="widgets" :miniAppType="miniAppType" />
			<div class="b_name pl-3">
				<div class="flex flex-column flex-align-start" style="justify-content: center">
					<EditableTextSpan :value.sync="titleValue" placeholder="Action Title" />
					<div class="header-description mt-n1">Modal</div>
				</div>
			</div>
		</div>
		<Row>
			<ActionCreditsRequiredMenu :action="creditsAction" v-if="showCreditsIcon" class="mr-2 mt-1" />
			<ActionUpgradeRequiredMenu :workflow="editWorkflow" :action="action" v-if="showUpgradeRequiredIcon" class="mr-2 mt-1" />
			<StepDropdownMenu showDeleteOnly />
		</Row>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapGetters, mapActions } from 'vuex';

import { AI_MINI_APP } from '../BlockEditor/BlockEditorAppSelect/BlockEditorAppSelect.const';
import ActionCreditsRequiredMenu from '@/components/BlockEditor/IntegrationEditor/ActionCreditsRequiredMenu.vue';
import ActionUpgradeRequiredMenu from '@/components/BlockEditor/IntegrationEditor/ActionUpgradeRequiredMenu.vue';
import StepDropdownMenu from '@/components/BlockEditor/StepDropdownMenu';
import ModuleTypeIcon from '@/components/common/ModuleTypeIcon/ModuleTypeIcon';
import { getAction } from '@/store/modules/actions/getters';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import AppActionService from '@/utils/AppActionService';
export default {
	name: 'BlockEditorWidgetHeader',
	components: { StepDropdownMenu, ModuleTypeIcon, ActionUpgradeRequiredMenu, ActionCreditsRequiredMenu },
	props: {
		miniAppType: { type: String },
	},
	computed: {
		...mapGettersShorthand({ getAction, editWorkflow }),
		...mapGetters('selectedNode', ['editNode']),
		titleValue: {
			set(value) {
				this.saveTitle(value);
			},
			get() {
				return this.editNode.node_title || '';
			},
		},
		action() {
			return this.getAction(this.editNode?.action);
		},
		showCreditsIcon() {
			return !!this.action?.credits_configuration && this.miniAppType == AI_MINI_APP;
		},
		creditsAction() {
			return {
				...this.action,
				is_credit_based: this.showCreditsIcon,
				credits_configuration: this.action?.credits_configuration[0][this.miniAppType],
			};
		},
		showUpgradeRequiredIcon() {
			return AppActionService.isActionRestricted(this.action);
		},
	},
	methods: {
		...mapActions('selectedNode', ['setParamInEditNode']),
		saveTitle: debounce(async function (value) {
			this.setParamInEditNode({ key: 'node_title', value });
		}, 600),
	},
};
</script>

<style scoped lang="scss">
.header-container {
	height: 69px;
	background: var(--header-background);
	border-bottom: 1px solid var(--border-color);

	.header-description {
		font-size: 12px;
		font-weight: 300;
		color: var(--bold-title);
	}

	.input-container {
		.b_name {
			::v-deep {
				.v-input__control {
					min-height: 32px;
				}
				.v-input__slot {
					padding: 0 !important;
					background: transparent;
				}
				input {
					opacity: 1;
					font-size: 20px;
					font-weight: 600;
					line-height: 22px;
					color: var(--bold-title);
				}
			}
		}
	}
}
</style>
